<template>
  <div class="sorter">
    <div v-for="(item, index) in sortingItems" :key="index" class="sorting-item" @click="sortBy(item.sortBy)">
      <div class="legend-square" :style="{ background: item.legendColor }" />
      <span style="font-weight: bold">{{ item.name }}</span>
      <span :hidden="sorting === `${item.sortBy}-asc` || sorting === `${item.sortBy}-desc`" class="sorting-arrow-slot"></span>
      <span :hidden="sorting !== `${item.sortBy}-asc`" class="sorting-arrow">↑</span>
      <span :hidden="sorting !== `${item.sortBy}-desc`" class="sorting-arrow">↓</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sortingItems: {
      type: Array,
      default: () => [
        {
          sortBy: 'aa',
          name: 'Padrão',
          legendColor: '#002040',
        },
      ],
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    sorting: '',
  }),
  mounted() {
    this.sorting = this.value
  },
  methods: {
    sortBy(sortingOption) {
      if (this.sorting.slice(3) === 'asc') this.sorting = sortingOption + '-' + 'desc'
      else if (this.sorting.slice(3) === 'desc') this.sorting = ''
      else this.sorting = sortingOption + '-' + 'asc'
      this.$emit('input', this.sorting)
    },
  },
}
</script>

<style lang="scss" scoped>
.sorter {
  display: flex;
  gap: 22px;
  padding-left: 20px;
  user-select: none;

  :hover {
    opacity: 0.8;
    cursor: pointer;
  }

  .legend-square {
    width: 10px;
    height: 10px;
  }

  .sorting-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    min-height: 36px;
  }

  .sorting-arrow {
    font-size: 24px;
  }

  .sorting-arrow-slot {
    width: 12px;
    height: 36px;
  }
}
</style>
